var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-registrants-login-wrapper" },
    [
      _setup.showButton && !_setup.isLoading
        ? _c(
            _setup.Button,
            {
              staticClass: "btn-light border btn-sm",
              nativeOn: {
                click: function ($event) {
                  return _setup.handleAutoLogin.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        Login\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }